import { MatDialogConfig } from '@angular/material/dialog';

export class ApplicationTemplateFormDialogConfig {
    public static readonly defaultDialogConfig: MatDialogConfig = {
        panelClass: 'application-template-form-dialog',
        width: '600px',
        height: '450px',
        disableClose: true,
    };
}
